import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-phone-field',
  templateUrl: './phone-field.component.html',
  styleUrls: ['./phone-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => PhoneFieldComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PhoneFieldComponent implements OnInit, ControlValueAccessor {
  // Input properties
  @Input() type: string | number = 'text';
  @Input() label: string = '';
  @Input() inputValue: string = '';
  @Input() customClass: string = '';
  @Input() placeholder: string = '';
  @Input() error: boolean = false;
  @Input() standard: boolean = false;
  @Input() disabled: boolean = false;
  @Input() required: boolean = false;
  @Input() autofocus: boolean = false;

  @ViewChild('inputRef', { static: false }) inputRef!: ElementRef;

  // Output property
  @Output() valueChanged = new EventEmitter<string>();

  ngOnInit(): void {
    if (this.autofocus) {
      setTimeout(() => this.inputRef.nativeElement.focus());
    }
  }

  onChange = (data: any) => {};
  onTouch = (_: any) => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(value: string) {
    this.inputValue = value;
    this.onChange(value);
  }

  // Handles input value changes
  onInputChange(event: any, isValue = false) {
    if (isValue) {
      this.inputValue = event;
      this.onChange(event);
      this.emitValueChanged(event);
    } else {
      const newValue = (event.target as HTMLInputElement).value;
      this.inputValue = newValue;
      this.onChange(newValue);
      this.emitValueChanged(newValue);
    }
  }

  // Emits the changed value
  private emitValueChanged(value: string) {
    this.valueChanged.emit(value);
  }
}
